import { forwardRef } from 'react';
import { useNumberFormat } from '@react-input/number-format';
import { Input, InputProps } from '../Input';

//@ts-ignore
export interface InputPriceProps extends InputProps {
  value?: number; // The value should be in cents
  onChange: (value: number) => void; // The value will be in cents
}

const formatPrice = (priceInCents: number) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(priceInCents / 100);
};

export const InputPrice = forwardRef<HTMLInputElement, InputPriceProps>(({ value, onChange, ...rest }) => {
  const inputRef = useNumberFormat({
    locales: 'en',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  return (
    <Input
      ref={inputRef}
      {...rest}
      value={value || value == 0 ? formatPrice(value) : ''}
      onChange={e => {
        const v = parseInt(e.target.value.replace(',', '').replace('.', ''));
        onChange(v);
      }}
    />
  );
});
